import { EyeFilled, EyeInvisibleFilled } from '@ant-design/icons';
import { Switch } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { ColumnBaseProps } from '../types';

const ByDefaultColumn: React.FC<ColumnBaseProps> = ({ record }) => {
  return (
    <Switch
      checkedChildren={<EyeFilled />}
      unCheckedChildren={<EyeInvisibleFilled />}
      checked={record.formField.defaultVisibility}
      disabled={record.formField.defaultVisibilityToggleModel.disabled}
      onClick={record.formField.defaultVisibilityToggleModel.toggle}
    />
  );
};

export default observer(ByDefaultColumn);
